module.exports = __webpack_public_path__ + "static/img/wxshop.2cfcd9bb.png";